/**
 * Types of notification agents.
 */
export enum AgentType {
  STUDENT = 'student',
  PARENT = 'parent',
}
